import angular from 'angular';
import uiRouter from 'angular-ui-router';
import localStorage from '../localstorage';
import translation from '../translation';
import account from '../account';
import service from './service';
import paymentController from './payment.controller';

const app = angular.module('klPayment', [uiRouter, localStorage, translation, account]);

service(app);
paymentController(app);

export default app.name;
